export const StringsEN = {
    // Header strings
    headerStrings: {
        button_whoWeAre: "About ARTIS",
        button_projects: "Projects",
        button_software: "Software",
        button_contact: "Contact",
    },
    // Footer
    footerStrings : {
        button_privacyPolicy: "Privacy policy",
        button_dataProtectionPolicy: "Data protection policy",
        button_cookiePolicy: "Cookies policy",
        button_ethicalChannel: "Ethical channel",
        button_qualityPolicy: "Quality policy",
        button_informationSecurityPolicy: "Security de policy",
        button_informationSecurityPolicyENS: "Security de policy ENS",
        button_transparencyPortal: "Transparency portal"
    },
    // Buttons
    buttons: {
        button_accept: "Accept",
        button_reject: "Decline"
    },
    // ---------- Pages ---------- //
    // Landing page
    landingPageStrings : {
        panel_1_title: "Improving body composition assessment through AI",
        panel_1_subtitle: "We develop software based on artificial intelligence to increase the utility of the clinical data to provide more personalized treatments",
        panel_2_string_1: "Over one billion people suffer from malnutrition globally. In Spain, malnutrition affects 30% of hospitalized patients, with a significant increase in older patients and those with multiple conditions",
        panel_2_string_2: "Sarcopenia affects 10% of the general population and up to 30% of hospitalized patients. It is linked to worse clinical outcomes, increased treatment needs, longer hospital stays, disability, and higher healthcare costs",
        panel_2_string_3: "International guidelines for the management of malnutrition and sarcopenia recommend routine body composition assessment",
        panel_3_string_1: "FocusedON",
        panel_3_string_2: "Software for a precise body composition analysis aiming a more personalized and efficient treatment.",
        panel_3_string_3: "FocusedON uses CT scan imaging information collected in a routine basis. Images are automatically processed using artificial intelligence to obtain useful information for the daily clinical practice.",
        panel_3_button: "More information",
        panel_4_string_1: "Developed from clinical research studies",
        panel_4_string_2: "Used in clinical studies with more than 1,000 patients",
        panel_4_string_3: "Provides metrics for specific clinical applications",
        panel_5_string_1: "Research and collaborations",
        panel_5_string_2: "Research is key to improve clinical practice. This is why we are open to new collaborations. Would you like to extend the scope of your research?",
        panel_5_button: "Contact us",
        panel_6_string_title: "FocusedON features",
        panel_6_string_list: [
            "Automatic segmentation of musculoskeletal tissue and visceral, subcutaneous, and intermuscular adipose tissue from abdominal CT scans",
            "Tissue quantity is provided in cm² and percentage, while tissue average radiodensity is given in Hounsfield Units",
            "Intuitive report files and research-friendly spreadsheets are obtained in under one minute per patient and CT scan",
        ],
        panel_7_string_1: "Certifications",
        panel_7_string_2: "Funding",
        panel_7_string_3: "Partners"
    },
    // Software page
    softwarePageStrings: {
        panel_1_string_1: "FocusedON",
        panel_1_string_2: "Software for a precise body composition analysis aiming a more personalized and efficient treatment.",
        panel_1_string_3: "FocusedON uses CT scan imaging information collected in a routine basis. Images are automatically processed using artificial intelligence to obtain useful information for the daily clinical practice.",
        panel_2_string_1: "Scientific facts",
        panel_2_string_2: "Body composition, defined as the proportion of skeletal muscle and adipose tissue, is recognized as a critical factor in disease prognosis and treatment planning.",
        panel_2_string_3: "This is because several clinical populations, including those with liver cirrhosis, various cancers, and critically ill patients, show worse clinical outcomes when abnormal body composition features (e.g., low skeletal muscle mass) are present.",
        panel_2_string_4: "Computed tomography (CT) scans, which are often acquired for clinical purposes (e.g., monitoring disease progression), can be analyzed to precisely segment skeletal muscle, intermuscular adipose tissue, visceral adipose tissue and subcutaneous adipose tissue.",
        panel_2_string_5: "Slices at the abdominal range, (e.g., slices at third lumbar vertebrae) can be used for consistent body composition analysis, as the skeletal muscle and adipose tissue in this region display strong associations with whole-body metrics of body composition.",
        panel_2_string_6: "FocusedON has been successfully used in multiple clinical studies to analyze body composition, providing valuable insights into disease prognosis and treatment response across various patient populations:",
        panel_3_string_global_title: "How FocusedON works",
        panel_3_string_list:[
            "FocusedON allows loading CT scan images stored according to DICOM standard",
            "The images are displayed in an intuitive manner to be easily visualized by the user",
            "FocusedON presents a user friendly interface to identify and select the slices to be analyzed",
            "The selected slices are rapidly processed by the artificial intelligence integrated in the software",
            "The skeletal muscle mass, the visceral adipose tissue, the subcutaneous adipose tissue and the intermuscular adipose tissue are automatically segmented",
            "Multiple metrics are provided for each tissue, including its absolute and relative quantity as well as its radiodensity, measured in Hounsfield Units",
            "The results of the body composition analysis are provided in a report file that includes both quantitative metrics and intuitive graphics",
            "The results are also provided in spreadsheets that can be easily integrated in the usual research methodologies to boost their efficiency",
        ],
        panel_3_string_demo: "Apply for a free demo",
    },
    // Contact page
    contactPageStrings : {
        box_top_message_title: "ARTIS Tech Development, S.L.",
        box_top_message_list: [
            "C/ Practicante Ignacio Rodríguez, S/N, Polivalente IV. Oficina 006.",
            "35017 Las Palmas de Gran Canaria. Spain.",
            "Phone: (0034) 928 767 608",
        ],
        box_email: "Email",
        box_message: "Message",
        box_policy_1: "I agree to the use of my data for the purposes specified under PRIVACY POLICY",
        box_policy_2: "I agree to the use of my data to receive marketing", 
        form_title: "Contact us",
        box_fullName: "Full name",
        box_company: "Company",
        box_phone: "Phone",
        box_geographicalArea: "Country",  
        button_submit: "Submit",
        error_requiredField: "Required field",
        waitingMessage_submittingForm: "Information is being submitted",
        success_title: "Information correctly submitted",
        success_message: "Thank you for your interest. Our team will contact you soon",
        error_title: "Error submitting information",
        error_message: "Please try again later. You can also contact us directly at info@artisdevelopment.com",
        data_protection_title: "Basic information on data protection",
        data_protection_sections : [
            {
                title: "Data controller",
                text: "ARTIS Tech Development, S.L."
            },{
                title: "Address",
                text: "C/ Practicante Ignacio Rodríguez, S/N, Polivalente IV. Oficina 006, CP 35017, Las Palmas de Gran Canaria (Las Palmas)"
            },{
                title: "Purposes",
                text: "We will use your data to respond to your requests and deliver our services to you."
            },{
                title: "Marketing",
                text: "We will only send you marketing correspondence if you have given your prior consent, which you can do by ticking the box for that purpose."
            },{
                title: "Lawful basis",
                text: "We will only process your data if you have given your prior consent, which you can do by ticking the box for that purpose."
            },{
                title: "Recipients",
                text: "In general, only the personnel of our entity that is duly authorized may have knowledge of the information that we request."
            },{
                title: "Your rights",
                text: "You have the right to know what information we hold about you, to rectify it and to erase it, as explained in the additional information available on our website."
            },{
                title: "Additional information",
                text: "For more information, please see PRIVACY POLICY on our website."
            },{
                title: "Contact data of our Data Protection Officer",
                text: "dpo@artisdevelopment.com"
            },
        ]
    },
    // Cookies
    cookies: {
        popupTitle: 'We use cookies to enhance your experience',
        popupText: 'We would like to use analytical cookies to understand how you interact with our website and to improve our services. These cookies collect information anonymously and help us analyze user traffic and behavior. By clicking Accept, you consent to the use of these cookies according to our Privacy Policy. You can change your preferences at any time.',
        popupText_1: 'We would like to use analytical cookies to understand how you interact with our website and to improve our services. These cookies collect information anonymously and help us analyze user traffic and behavior. By clicking Accept, you consent to the use of these cookies according to our ',
        popupText_2: 'Cookie Policy',
        popupText_3: '. You can change your preferences at any time.',
    },
    // ---------- Alts for images and videos ---------- //
    alts: {
        logo_artis: 'ARTIS Development logo',
        problemImage_malnutritionPatient: 'An elderly person hospitalized due to malnutrition',
        problemImage_malnutritionCancer: 'A hospitalized person with sarcopenia and cancer',
        problemImage_malnutritionGuides: 'International guidelines for the management of sarcopenia and malnutrition based on body composition',
        focusedon_overview: "Global overview of FocusedON, showing a CT scan at the level of the lumbar vertebra L3, where tissues related to body composition have been segmented (skeletal muscle tissue, visceral fat, subcutaneous fat, and intermuscular fat).",
        focusedon_video: "Short video demonstrating the functionality of FocusedON, showing how the lumbar vertebra L3 is selected, the image is automatically segmented using artificial intelligence for body composition analysis, and a detailed PDF report is generated with the amount of skeletal muscle tissue, visceral fat, subcutaneous fat, and intermuscular fat.",
        focusedon_report: "Detailed report generated by FocusedON, showing the amount of each segmented tissue for body composition analysis (skeletal muscle tissue, visceral fat, subcutaneous fat, and intermuscular fat), along with their average radiological density in Hounsfield Units (HU)."
    }
}